import React from "react";
import logo from "../UI/assets/logo.svg";
import styles from "./OnboardingShell.module.css";

/*
 * Shared frame for the onboarding steps.
 * Puts the wordmark, a white card, and "Step n of 4" on the admin gray page.
 *
 * Example:
 *   <OnboardingShell step={1}> card + "Step 1 of 4" </OnboardingShell>
 *   <OnboardingShell> card only, used by the upgrade-plan route </OnboardingShell>
 */
const OnboardingShell = ({ step, stepNote, logoId, children }) => {
  return (
    <div className={styles.page}>
      <img
        id={logoId}
        className={styles.logo}
        src={logo}
        alt="Inventory Forecasting Hero"
      />
      <div className={styles.card}>{children}</div>
      {step ? (
        <p className={styles.step}>
          Step {step} of 4
          {stepNote ? <span className={styles.stepNote}> · {stepNote}</span> : null}
        </p>
      ) : null}
    </div>
  );
};

export default OnboardingShell;
